import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import configureStore from './redux/store';
import reportWebVitals from './reportWebVitals';
import { AppRouter } from './router';

import 'react-toastify/dist/ReactToastify.css';
import './styles/styles.scss';
import './translations/i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastContainer />
      <ReduxProvider store={configureStore()}>
        <AppRouter />
      </ReduxProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
